export function waveEffect() {
    const btns = document.querySelectorAll('button.btn');

    btns.forEach(el => {
        el.addEventListener('mouseenter', function(e) {
            if (this.querySelector('.wave')) {
                return;
            }

            const size = Math.max(this.offsetWidth, this.offsetHeight),
                x = e.offsetX - size / 2,
                y = e.offsetY - size / 2,
                wave = document.createElement('span');

            wave.className = 'wave';
            wave.style.cssText = `width:${size}px;height:${size}px;top:${y}px;left:${x}px`;
            this.appendChild(wave);

            setTimeout(() => wave.remove(), 500);
        });
    });
}
